module.exports = __webpack_public_path__ + "static/media/Accounts.6c767a77.svg";